// src/modules/app-views/services/pages/Document/tabs/CostsTab/CostCalculationCard.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Card, Col, Row } from 'antd';
import { ROW_GUTTER } from 'constants/ThemeConstant';
import translateX from 'utils/translateX';
import SimpleCurrency from 'components/SimpleComponents/SimpleCurrency';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const CostCalculationCard = () => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 2. HOOKS & REFS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 3. LOCAL VARIABLES I
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 4. LOCAL STATE
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 5. EFFECTS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 6. HANDLERS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 7. LOCAL VARIABLES II
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <Card title={<div className="text-muted">{translateX('calculation_and_profit')}</div>}>
      <Row gutter={ROW_GUTTER}>
        <Col xs={24} sm={8} lg={4}>
          <SimpleCurrency
            name="cost"
            label="cost"
            currencies={[{ value: 'BRL', label: 'R$', text: 'Real Brasileiro' }]}
          />
        </Col>
      </Row>
    </Card>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default CostCalculationCard;
